const { cxt } = require('./context');

const bankAccountName = [
  'whitespace',
  cxt('pattern', { pattern: /^[A-Za-z0-9 ]{1,16}$/ }),
];

const bankAccountNumber = [
  'whitespace',
  cxt('pattern', { pattern: /^[0-9]{1,9}$/ }),
];

module.exports = {
  bankAccountName,
  bankAccountNumber,
};
